import { useMemo } from 'react';
import { useQuery } from '@supabase-cache-helpers/postgrest-swr';

import { supabase } from 'src/auth/context/supabase/lib';

import { useGetEntityById } from './entity';

export function useGetUserEntityPermissions(userId, entityId) {
  const { data, isLoading, error } = useQuery(
    userId && entityId
      ? supabase.from('users_entities').select('*').eq('user_id', userId).eq('entity_id', entityId)
      : null
  );

  return {
    permissions: data || null,
    isLoading,
    error,
  };
}

export function useGetUserPermissions(userId) {
  const { data, isLoading, error } = useQuery(
    userId ? supabase.from('users_entities').select('*').eq('user_id', userId) : null
  );

  return {
    permissions: data || null,
    isLoading,
    error,
  };
}

// Nouvelle fonction pour vérifier les permissions avancées
export function useGetAdvancedUserPermissions(userId, entityId) {
  const {
    permissions: directPermissions,
    isLoading: directLoading,
    error: directError,
  } = useGetUserEntityPermissions(userId, entityId);

  const { entity, entityLoading } = useGetEntityById(entityId);

  const {
    permissions: parentPermissions,
    isLoading: parentLoading,
    error: parentError,
  } = useGetUserEntityPermissions(userId, entity?.parent);

  const { permissions: allUserPermissions, isLoading: allPermissionsLoading } =
    useGetUserPermissions(userId);

  return useMemo(() => {
    const isLoading = directLoading || entityLoading || parentLoading || allPermissionsLoading;
    const error = directError || parentError;

    const isParentAdmin = parentPermissions?.[0]?.is_admin ?? false;
    const hasDirectAccess = directPermissions?.[0]?.can_access_ges ?? false;
    const hasChildAccess =
      entity?.is_parent &&
      allUserPermissions?.some((perm) => perm.can_access_ges && perm.entity_id !== entityId);

    return {
      hasAccess: isParentAdmin || hasDirectAccess,
      hasChildAccess,
      permissions: directPermissions?.[0],
      parentPermissions: parentPermissions?.[0],
      isLoading,
      error,
    };
  }, [
    directLoading,
    entityLoading,
    parentLoading,
    allPermissionsLoading,
    directError,
    parentError,
    parentPermissions,
    directPermissions,
    entity?.is_parent,
    allUserPermissions,
    entityId,
  ]);
}
